<ng-container *ngIf="status">
    <p>{{ 'INIT.ERROR.' + status | translate }}</p>
    <div class="row">
        <div translate class="col-2 f-b">INIT.STATUS</div>
        <div class="col-10">{{ status }}</div>
    </div>
    <div class="row">
        <div translate class="col-2 f-b">INIT.MSG</div>
        <div class="col-10">{{ message }}</div>
    </div>
</ng-container>

<ng-container *ngIf="!status">

    <ng-container *ngIf="!isDbInit">
        <p>{{ 'INIT.STEP_ADMIN' | translate }}</p>
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{'SIGNIN.PASS' | translate }}</mat-label>
            <mat-icon matPrefix class="mr-2">lock</mat-icon>
            <input matInput [formControl]="passControl" type="password" name="password" required >
            <mat-hint>{{ 'SIGNIN.PASSWORD_LENGTH' | translate }}</mat-hint>
        </mat-form-field>
        <div>
            <button mat-button (click)="initDb(stepper,passControl.value)" [disabled]="loading || !passControl.valid" color="primary">{{ 'GENERIC.SUBMIT' | translate }}</button>
        </div>
    </ng-container>
    <div *ngIf="isDbInit" class="success">
        <p>
        <mat-icon aria-hidden="false">{{ 'GENERIC.DONE' | translate }}</mat-icon> <span class="step-text"> {{ 'INIT.STEP_ADMIN_OK' | translate }} </span>
        </p>
        <button mat-raised-button [routerLink]="['/init','licence']" color="primary">{{ 'GENERIC.NEXT' | translate }}</button>
    </div>
</ng-container>